module.exports = __webpack_public_path__ + "static/media/liveOrder.f2f2dd6d.svg";